module.exports = __webpack_public_path__ + "img/test03-4.49e5f34c.jpg";